<template>
  <div
    class="flex-row rounded-sm bg-white shadow-xs"
    :class="[border?.colorClass, border?.widthClass, { 'px-6': hasPadding }]"
  >
    <div
      v-if="$slots.header"
      class="flex items-center justify-between"
      :class="{
        'border-b': hasHeaderDivider,
        'pb-6': hasHeaderPadding,
        'mb-6': hasHeaderMargin,
      }"
    >
      <div
        class="absolute right-10 z-50 mt-11-5"
        v-tooltip="{ content: $t('COMMON.COPY_LINK'), placement: 'bottom' }"
      >
        <slot name="copyLink" />
      </div>
      <slot name="header"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from "vue";

defineProps({
  hasHeaderDivider: {
    type: Boolean,
    default: true,
  },
  border: {
    type: Object as PropType<Record<string, string>>,
    default: () => ({}),
  },
  hasPadding: {
    type: Boolean,
    default: true,
  },
  hasHeaderPadding: {
    type: Boolean,
    default: true,
  },
  hasHeaderMargin: {
    type: Boolean,
    default: true,
  },
  copyLink: {
    type: String,
    default: "",
  },
});
</script>
